// ======================================================================
// File Name       : ContentLinkAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import * as ActionTypes from '../../constants/actionTypes/content';
import * as contentLinkRequest from '../httpRequests/contentLink';

export function searchContentLinkList(param) {
  return dispatch =>
    contentLinkRequest
      .searchContentLinkList(param)
      .then((result) => {
        if (param && param.selectTargetData) {
          const link = document.createElement('a');
          if (result && result.csvfileUrl) {
            link.href = result.csvfileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          dispatch(receiveContentLinkList(result));
        }
      });
}

export function receiveContentLinkList(result) {
  return {
    type: ActionTypes.CONTENT_LINK_LIST,
    contentLinkInfo: result,
  };
}

export function contentLinkEdit(param) {
  return dispatch =>
    contentLinkRequest
      .contentLinkEdit(param)
      .then((result) => {
        dispatch(receiveContentLinkEdit(result));
      });
}

export function receiveContentLinkEdit(result) {
  return {
    type: ActionTypes.CONTENT_LINK_EDIT,
    contentLinkInfo: result,
  };
}
